module.exports = __webpack_public_path__ + "static/media/dashboard_illustration.f4988d66.svg";